import React, { useEffect } from 'react';


function TeachingStaff() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (

        <div className={'teachingstaffpage'}>

            {/* ----- Teaching Staff Banner ----- */}

            <section className="academics-banner">
                <img src="images/banner-images/teaching-staff.jpg" alt="TeachingStaff_Banner" />
            </section>

            {/* ----- Teaching Staff Banner ----- */}

            {/* ----- Overview ----- */}

            <section className="overview">
                <div className="container">
                    <div className="overview-box">
                        <p className="para-18">Rainbow International School,Nagrota Bagwan is established by Diwan Chand Memorial Educational Society which is running three schools in Delhi and three schools in Himachal Pradesh. It is a Co- educational day boarding school with approximately 2000 students on its rolls. Rainbow School is dedicated towards imparting quality education.The school aims at all round development of young minds. The school is having safe and secure infrastructure with all the basic facilities required for the students. All the classrooms are spacious , airy and having smart class facility. Life at RIS, Nagrota Bagwan centres on a shared commitment to academic excellence, intellectual growth, art , athletics,high standards of ethical awareness, sportsmanship and community service. The school's tradition and accessibility to a broad curriculum adds depth to each student's life. The school upholds the founder's commitment to excellence in all fields with emphasis on its motto "HONEST LABOUR PAYS".</p>
                    </div>
                </div>
            </section>

            {/* ----- Overview ----- */}

            {/* ----- Overview ----- */}

            <section className="about-gd-block">
                <div className="container">
                    <h2 className="hdng-h2">Faculty</h2>
                    <p className="para-18">The faculty of Rainbow International School, Nagrota Bagwan shapes it's special character.Each faculty member is both a teacher and a scholar,an expert in his or her own field.The faculty of RIS consists of highly qualified teachers,who have extensive teaching experience in their respective fields.</p>
                </div>
            </section>

            {/* ----- Overview ----- */}


            {/* ----- Priciple ----- */}

            <section className="teacher-block">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Founder and Visionary</h2>
                            <div className="alumni-box">
                                <img src="images/staff-images/principle3.jpg" alt="Principle_Img" />
                                <h4>Dr J.R Kashyap</h4>
                                <p>Director Rainbow Group of Schools (Delhi & Himachal)</p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <h2>Leading the Way</h2>
                            <div className="alumni-box">
                                <img src="images/staff-images/principle1.jpg" alt="Principle_Img" />
                                <h4>Dr. Chhavi Kashyap</h4>
                                <p>Principal</p>
                            </div>
                        </div>

                        <h2>Stalwart</h2>
                        <div className="col-md-6">
                            <div className="alumni-box left">
                                <img src="images/staff-images/madhu-chaudhary.jpg" alt="Principle_Img" />
                                <h4>Mrs. Madhu Chaudhary</h4>
                                <p>Administrative Manager</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="alumni-box right">
                                <img src="images/staff-images/renu-maratha.jpg" alt="Teacher_Img" />
                                <h4>Mrs. Renu Maratha </h4>
                                <p>Academic Head</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* ----- Priciple ----- */}


            {/* ----- Alumni ----- */}

            <section className="staff-block staff-even">
                <div className="container">
                    <h2 className="hdng-h2">Teaching Staff (PGT)</h2>
                    <div className="alumni-cnt">
                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/neelam-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Neelam Sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/sunita-rani.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Sunita Rani</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/chanda.jpg" alt="Teacher_Img" />
                            <h4>Mr. Chanda</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/jayoti-vaidaya.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Jayoti Vaidaya</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/komal-guleria.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Komal Guleria</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/monika-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Monika Sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/seema-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Seema Sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/munish-kumar.jpg" alt="Teacher_Img" />
                            <h4>Mr. Munish Kumar</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/vikas-dhiman.jpg" alt="Teacher_Img" />
                            <h4>Mr. Vikas Dhiman</h4>
                        </div>


                        <div className="alumni-box">
                            <img src="images/staff-images/PGT/rameshwar.jpg" alt="Teacher_Img" />
                            <h4>Mr. Rameshwar</h4>
                        </div>
                    </div>
                </div>
            </section>

            {/* ----- Alumni ----- */}


            {/* ----- Alumni ----- */}

            <section className="staff-block">
                <div className="container">
                    <h2 className="hdng-h2">Teaching Staff (TGT)</h2>
                    <div className="alumni-cnt">

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/sarita-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Sarita Sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/namita-walia.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Namita Walia</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/sunita-katoch.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Sunita Katoch</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/namita-gupta.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Namita Gupta</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/arpana-devi.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Arpana Devi</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/sanjay-kumar.jpg" alt="Teacher_Img" />
                            <h4>Mr. Sanjay Kumar</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/paramjit-singh.jpg" alt="Teacher_Img" />
                            <h4>Mr. Paramjit Singh</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/vinod-kumar.jpg" alt="Teacher_Img" />
                            <h4>Mr. Vinod Kumar</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/sakshi.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Sakshi</h4>
                        </div>


                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/pratima.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Pratima</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/renu-bala.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Renu Bala</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/rimpi-devi.jpg" alt="Teacher_Img2" />
                            <h4>Mrs. Rimpi Devi</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/sarita-dadwal.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Sarita Dadwal</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/anuja-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Anuja Sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/poonam.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Poonam</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/rajni-devi.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Rajni Devi</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/sapna.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Sapna</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/TGT/shivani-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Shivani Sharma</h4>
                        </div>
                    </div>
                </div>
            </section>

            {/* ----- Alumni ----- */}


            {/* ----- Alumni ----- */}

            <section className="staff-block staff-even">
                <div className="container">
                    <h2 className="hdng-h2">Teaching Staff (PRT)</h2>
                    <div className="alumni-cnt">
                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/maan-singh.jpg" alt="Teacher_Img" />
                            <h4>Mr. Maan Singh</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/mool-raj.jpg" alt="Teacher_Img" />
                            <h4>Mr. Mool raj </h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/anu-bala.jpg" alt="Teacher_Img" />
                            <h4>Mr. anu bala</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/richa-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Richa Sharma </h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shalu-guleria.jpg" alt="Teacher_Img" />
                            <h4>Mrs. shalu guleria</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shivani-thakur.jpg" alt="Teacher_Img" />
                            <h4>Mrs. shivani thakur</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/sona-thapa.jpg" alt="Teacher_Img" />
                            <h4>Mrs. sona thapa</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/amna.jpg" alt="Teacher_Img" />
                            <h4>Mrs. amna</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/arti-paniyal.jpg" alt="Teacher_Img" />
                            <h4>Mrs. arti rajput</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/katayani-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. katayani sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/manisha.jpg" alt="Teacher_Img" />
                            <h4>Mrs. Manisha</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/nandani-mehra.jpg" alt="Teacher_Img" />
                            <h4>Mrs. nandini Mehra</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/neelam-kumari.jpg" alt="Teacher_Img" />
                            <h4>Mrs. neelam kumari</h4>
                        </div>
                        
                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/radhika.jpg" alt="Teacher_Img" />
                            <h4>Mrs. radhika </h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/rashi-sood.jpg" alt="Teacher_Img" />
                            <h4>Mrs. rashi sood</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/renuka-bala.jpg" alt="Teacher_Img" />
                            <h4>Mrs. renuka bala</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/ritu-bhardwaj.jpg" alt="Teacher_Img" />
                            <h4>Mrs. ritu bhardwaj</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/samita-sood.jpg" alt="Teacher_Img" />
                            <h4>Mrs. samita sood</h4>
                        </div>


                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/seema-bhardwaj.jpg" alt="Teacher_Img" />
                            <h4>Mrs. seema bhardwaj</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shalini-chopra.jpg" alt="Teacher_Img" />
                            <h4>Mrs. shalini chopra</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shivani-jamwal.jpg" alt="Teacher_Img" />
                            <h4>Mrs. shivani jamwal</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/sonali-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. sonali sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/vandna-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. vandna Sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/kavita-guleria.jpg" alt="Teacher_Img" />
                            <h4>Ms. kavita guleria</h4>
                        </div>



                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/ankush-mehra.jpg" alt="Teacher_Img" />
                            <h4>Mr. ankush mehra</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shashi-bhushan.jpg" alt="Teacher_Img" />
                            <h4>Mr. shashi bhushan</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/aditi-kanwar.jpg" alt="Teacher_Img" />
                            <h4>Mrs. aditi kanwar</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/asha-devi.jpg" alt="Teacher_Img" />
                            <h4>Mrs. asha devi</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/manju-jaggi.jpg" alt="Teacher_Img" />
                            <h4>Mrs. manju jaggi</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/neena-datt.jpg" alt="Teacher_Img" />
                            <h4>Mrs. neena datt</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shilpi-thakur.jpg" alt="Teacher_Img" />
                            <h4>Mrs. shilpi thakur</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/shivani-sharma.jpg" alt="Teacher_Img" />
                            <h4>Mrs. shivani sharma</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/divya-katoch.jpg" alt="Teacher_Img" />
                            <h4>Ms. divya katoch</h4>
                        </div>

                        <div className="alumni-box">
                            <img src="images/staff-images/PRT/tamanna-grover.jpg" alt="Teacher_Img" />
                            <h4>Ms. tamanna grover</h4>
                        </div>
                    </div>
                </div>
            </section>

            {/* ----- Alumni ----- */}


            {/* ----- Alumni ----- */}
            <section className="staff-block staff-even">
                <div className="container">
                    <h2 className="hdng-h2">German Language Department</h2>
                    <div className="alumni-cnt hdgfn">
                            <div className="alumni-box">
                                <img src="images/staff-images/PRT/ravindra.jpg" alt="Teacher_Img" />
                                <h4>Mr. Ravindra Singh</h4>
                                <p>P.G.T German & Head of the German Department M.A German Distinction (Gold Medalist), B.ed</p>
                        </div>
                            <div className="alumni-box">
                                <img src="images/staff-images/german/Seijal.png" alt="Seijal " />
                                <h4>Ms. Seijal Khurana</h4>
                                <p>Goethe-Zertifikat B1</p>
                            </div>
                    </div>
                </div>
            </section >
            {/* ----- Alumni ----- */}


        </div >




    )
}


export default TeachingStaff